module.exports = __webpack_public_path__ + "static/media/lightyear-logo@2x.e33ef4d2.png";